import { render, staticRenderFns } from "./ClientInfoMain.vue?vue&type=template&id=829edcdc&scoped=true"
import script from "./ClientInfoMain.vue?vue&type=script&lang=js"
export * from "./ClientInfoMain.vue?vue&type=script&lang=js"
import style0 from "./ClientInfoMain.vue?vue&type=style&index=0&id=829edcdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "829edcdc",
  null
  
)

export default component.exports